import { call } from 'redux-saga/effects'
import { treeHandlers } from 'react-hyper-tree'
import get from 'lodash/get'
import updateNodeCount from '@/helpers/updateNodeCount'
import { getInstallationTreeNode } from '@/helpers/installationTreeNode'

export function* refreshInstallationTreeParent({
  parentId,
  nodeId,
  path,
}) {
  const tree = treeHandlers.trees['installations-tree']
  const parent = getInstallationTreeNode(tree, parentId)

  if (!parent?.data?.getChildren) {
    return false
  }

  const parentChildren = yield call(parent.data.getChildren, parent)
  tree.handlers.setRawChildren(parent, parentChildren, 'first', true)

  if (nodeId) {
    const node = getInstallationTreeNode(tree, nodeId)
    if (node) {
      if (path) {
        updateNodeCount(tree, path, 'add')
      }
      const selectedNodePath = get(node, 'options.path', '')
      if (selectedNodePath) {
        tree.handlers.setSelectedByPath(selectedNodePath)
      }
    }
  }

  return true
}
